const SCROLLBAR_WHITE_CLASS = 'scrollbar-white';
let refCount = 0;

function sync(): void {
	if (typeof document === 'undefined') return;
	document.body.classList.toggle(SCROLLBAR_WHITE_CLASS, refCount > 0);
}

/**
 * Add the design-system `scrollbar-white` body class while a New-Layout-V2
 * layout is mounted. A shared reference count keeps the class active when
 * multiple V2 layouts overlap during route transitions. Returns an idempotent
 * release function that removes the class after the final layout unmounts.
 */
export function acquireScrollbarWhite(): () => void {
	refCount += 1;
	sync();

	let released = false;
	return () => {
		if (released) return;
		released = true;
		refCount -= 1;
		sync();
	};
}
